import React from 'react';
import classNames from 'classnames';
import { RouteList } from 'api/routes';
import styles from './appbar.module.scss';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import {
    SetScrollPosActionFavouriteQuestionsPage,
    SetScrollPosActionHomePage,
    SetScrollPosActionCollaborationsPage,
    SetScrollPosActionPremiumBrowsePage,
    SetScrollPosActionProBrowsePage,
    SetScrollPosActionProHomePage,
    setScrollPosFavouriteQuestionsPage,
    setScrollPosHomePage,
    setScrollPosCollaborationsPage,
    setScrollPosPremiumBrowsePage,
    setScrollPosProBrowsePage,
    setScrollPosProHomePage,
} from 'store-modules/app-settings';
import { clearConversationSwiperPositions } from 'store-modules/conversation-swiper-positions';
import { useWindowSize } from 'hooks';

interface Props {
    routes: RouteList;
}

const Appbar: React.FC<Props> = ({ routes }: Props) => {
    const dispatch = useDispatch();

    const { view } = useWindowSize(window);
    const isMobile = view === 'mobile';

    const clearScrollPosHomePage = (): SetScrollPosActionHomePage =>
        dispatch(setScrollPosHomePage({ x: 0, y: 0 }));
    const clearScrollPosPremiumBrowsePage =
        (): SetScrollPosActionPremiumBrowsePage =>
            dispatch(setScrollPosPremiumBrowsePage({ x: 0, y: 0 }));
    const clearScrollPosProHomePage = (): SetScrollPosActionProHomePage =>
        dispatch(setScrollPosProHomePage({ x: 0, y: 0 }));
    const clearScrollPosProBrowsePage = (): SetScrollPosActionProBrowsePage =>
        dispatch(setScrollPosProBrowsePage({ x: 0, y: 0 }));
    const clearScrollPosFavouriteQuestionsPage =
        (): SetScrollPosActionFavouriteQuestionsPage =>
            dispatch(setScrollPosFavouriteQuestionsPage({ x: 0, y: 0 }));
    const clearScrollPosCollaborationsPage =
        (): SetScrollPosActionCollaborationsPage =>
            dispatch(setScrollPosCollaborationsPage({ x: 0, y: 0 }));

    const clearScrollPositions = () => {
        clearScrollPosHomePage();
        clearScrollPosPremiumBrowsePage();
        clearScrollPosProHomePage();
        clearScrollPosProBrowsePage();
        clearScrollPosFavouriteQuestionsPage();
        clearScrollPosCollaborationsPage();

        dispatch(clearConversationSwiperPositions());
    };

    return (
        <nav
            className={styles.appbar}
            style={
                isMobile
                    ? {
                          background: '#001133',
                          boxShadow: '0px -6px 20px 0px rgba(0, 17, 51, 0.21)',
                      }
                    : {}
            }
        >
            <ul className={styles.list}>
                <li className={styles.item}>
                    <NavLink
                        className={({ isActive }) =>
                            classNames(styles.link, styles.homeIcon, {
                                [styles.active]: isActive,
                                [styles.mobile]: isMobile,
                            })
                        }
                        end
                        onClick={clearScrollPositions}
                        to={routes.index}
                    >
                        <span className={styles.indicator} />
                    </NavLink>
                </li>

                {/* {!!organization && organization.name == user?.organization && ( */}
                <li className={styles.item}>
                    <NavLink
                        className={({ isActive }) =>
                            classNames(styles.link, styles.proIcon, {
                                [styles.active]: isActive,
                                [styles.mobile]: isMobile,
                            })
                        }
                        onClick={clearScrollPositions}
                        to={routes.proindex}
                    >
                        <span className={styles.indicator} />
                    </NavLink>
                </li>
                {/* )} */}

                <li className={styles.item}>
                    <NavLink
                        className={({ isActive }) =>
                            classNames(styles.link, styles.searchIcon, {
                                [styles.active]: isActive,
                                [styles.mobile]: isMobile,
                            })
                        }
                        to={routes.search}
                    >
                        <span className={styles.indicator} />
                    </NavLink>
                </li>

                <li className={styles.item}>
                    <NavLink
                        to={routes.myLibrary}
                        className={({ isActive }) =>
                            classNames(styles.link, styles.heartIcon, {
                                [styles.active]: isActive,
                                [styles.mobile]: isMobile,
                            })
                        }
                        end
                        onClick={clearScrollPositions}
                    >
                        <span className={styles.indicator} />
                    </NavLink>
                </li>

                {/* {!isMobile && ( */}
                <li className={styles.item}>
                    <NavLink
                        className={({ isActive }) =>
                            classNames(styles.link, styles.userIcon, {
                                [styles.active]: isActive,
                                [styles.mobile]: isMobile,
                            })
                        }
                        to={routes.account.index}
                    >
                        <span className={styles.indicator} />
                    </NavLink>
                </li>
                {/* )} */}
            </ul>
        </nav>
    );
};

export default Appbar;
